/*
 * Trial Offer – picker logic (welcome-bk-trial-offer page template)
 * - Pick up to N products; others gray out
 * - Trial Box updates live; mobile step 2 ("review")
 * - Checkout: clear cart (optional) → set cart attribute → native form POST to
 *   /cart/add with return_to=/checkout (full redirect, so slide carts never open)
 */
(function () {
  'use strict';

  function fill(str, map) {
    return String(str || '').replace(/\[(\w+)\]/g, function (m, k) {
      return Object.prototype.hasOwnProperty.call(map, k) ? map[k] : m;
    });
  }

  function shipDay(cfg) {
    var t = cfg.text;
    try {
      var parts = new Intl.DateTimeFormat('en-US', {
        timeZone: cfg.ship.timeZone || 'America/Denver',
        weekday: 'short',
        hour: 'numeric',
        hourCycle: 'h23'
      }).formatToParts(new Date());
      var wd = (parts.find(function (x) { return x.type === 'weekday'; }) || {}).value;
      var hr = parseInt((parts.find(function (x) { return x.type === 'hour'; }) || {}).value, 10) % 24;
      var cutoff = Number(cfg.ship.cutoffHour);
      if (wd === 'Sat' || wd === 'Sun' || (wd === 'Fri' && hr >= cutoff)) return t.shipMonday;
      if (hr >= cutoff) return t.shipTomorrow;
      return t.shipToday;
    } catch (e) {
      return t.shipToday;
    }
  }

  function hideDrawers(selectors) {
    if (!selectors) return;
    var style = document.getElementById('trial-offer-hide-drawers');
    if (!style) {
      style = document.createElement('style');
      style.id = 'trial-offer-hide-drawers';
      document.head.appendChild(style);
    }
    style.textContent = selectors + '{display:none !important;visibility:hidden !important;}' +
      'html,body{overflow:auto !important;}';
  }

  function postJSON(url, body) {
    return fetch(url, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(body || {})
    }).then(function (r) {
      if (!r.ok) {
        return r.json().catch(function () { return {}; }).then(function (j) { throw j; });
      }
      return r.json().catch(function () { return {}; });
    });
  }

  function init(root) {
    if (!root || root.__trialOffer) return;
    root.__trialOffer = true;

    var cfgEl = root.querySelector('[data-to-config]');
    if (!cfgEl) return;
    var cfg = JSON.parse(cfgEl.textContent);
    var t = cfg.text;
    var max = Number(cfg.maxPicks) || 2;
    var cartRoot = cfg.cartRoot || '/';
    if (cartRoot.slice(-1) !== '/') cartRoot += '/';

    var cards = Array.prototype.slice.call(root.querySelectorAll('[data-to-card]'))
      .filter(function (c) { return c.querySelector('[data-to-pick]'); });
    var slotsEl = root.querySelector('[data-to-slots]');
    var tplFilled = root.querySelector('[data-to-slot-filled]');
    var tplEmpty = root.querySelector('[data-to-slot-empty]');
    var mainCtaText = root.querySelector('[data-to-cta-text]');
    var errorEl = root.querySelector('[data-to-error]');
    var form = root.querySelector('[data-to-form]');
    var mobile = window.matchMedia('(max-width: 989px)');

    var sel = [];
    var step = 'pick';
    var busy = false;

    function card(id) {
      for (var i = 0; i < cards.length; i++) if (cards[i].dataset.id === id) return cards[i];
      return null;
    }

    function scrollToRoot() {
      var top = root.getBoundingClientRect().top + window.pageYOffset - 20;
      window.scrollTo({ top: Math.max(top, 0), behavior: 'smooth' });
    }

    function setStep(next) {
      step = next;
      render();
      scrollToRoot();
    }

    function toggle(id) {
      var i = sel.indexOf(id);
      if (i !== -1) {
        sel.splice(i, 1);
        if (!sel.length) step = 'pick';
        render();
        return;
      }
      if (sel.length >= max) return;
      sel.push(id);
      if (sel.length === max && cfg.autoReview && mobile.matches) {
        setStep('review');
      } else {
        render();
      }
    }

    function render() {
      var count = sel.length;
      var full = count >= max;
      var left = max - count;

      root.classList.toggle('is-review', step === 'review' && count > 0);
      root.classList.toggle('has-picks', count > 0);

      cards.forEach(function (c) {
        var on = sel.indexOf(c.dataset.id) !== -1;
        var off = !on && full;
        var btn = c.querySelector('[data-to-pick]');
        c.classList.toggle('is-selected', on);
        c.classList.toggle('is-disabled', off);
        btn.disabled = off;
        btn.setAttribute('aria-pressed', on ? 'true' : 'false');
        btn.textContent = on ? t.btnAdded : (off ? t.btnFull : t.btnAdd);
      });

      var status = root.querySelector('[data-to-status]');
      if (status) status.textContent = count === 0 ? fill(t.statusEmpty, { left: left }) : (full ? t.statusFull : fill(t.statusSome, { left: left }));
      var pill = root.querySelector('[data-to-count-pill]');
      if (pill) pill.textContent = count + '/' + max + ' ' + (t.picked || '');
      var boxCount = root.querySelector('[data-to-count]');
      if (boxCount) boxCount.textContent = count + '/' + max;

      var b1 = root.querySelector('[data-to-banner-one]');
      var b2 = root.querySelector('[data-to-banner-full]');
      if (b1) b1.hidden = !(count > 0 && !full);
      if (b2) b2.hidden = !full;

      // slots
      if (slotsEl && tplFilled && tplEmpty) {
        slotsEl.innerHTML = '';
        for (var s = 0; s < max; s++) {
          var id = sel[s];
          var c = id ? card(id) : null;
          var node;
          if (c) {
            node = tplFilled.content.firstElementChild.cloneNode(true);
            var img = node.querySelector('.to-slot__img');
            if (c.dataset.image) {
              img.src = c.dataset.image;
              img.alt = c.dataset.title;
            } else {
              img.remove();
            }
            node.querySelector('.to-slot__media').style.background = c.dataset.tint || '';
            node.querySelector('.to-slot__name').textContent = c.dataset.title;
            node.querySelector('.to-slot__was').textContent = c.dataset.price;
            var bp = node.querySelector('[data-to-benefit-price]');
            if (bp) bp.textContent = fill(bp.textContent, { price: c.dataset.price });
            var rm = node.querySelector('[data-to-remove]');
            rm.dataset.toRemove = id;
            rm.setAttribute('aria-label', (t.remove || 'Remove') + ' ' + c.dataset.title);
          } else {
            node = tplEmpty.content.firstElementChild.cloneNode(true);
            node.querySelector('.to-slot__empty-label').textContent = fill(t.slotEmpty, { n: s + 1 });
          }
          slotsEl.appendChild(node);
        }
      }

      var addMore = root.querySelector('[data-to-add-more]');
      if (addMore) addMore.hidden = !(count > 0 && !full);

      Array.prototype.forEach.call(root.querySelectorAll('[data-to-checkout]'), function (b) {
        b.disabled = count === 0 || busy;
      });
      if (mainCtaText && !busy) {
        mainCtaText.textContent = count === 0 ? t.ctaEmpty : (full ? t.ctaFull : fill(t.ctaSome, { count: count }));
      }

      var day = root.querySelector('[data-to-ship-day]');
      if (day) day.textContent = shipDay(cfg);
    }

    function setBusy(on) {
      busy = on;
      root.classList.toggle('is-busy', on);
      if (mainCtaText) mainCtaText.textContent = on ? t.ctaLoading : '';
      render();
    }

    function showError(msg) {
      if (!errorEl) return;
      errorEl.textContent = msg || t.error;
      errorEl.hidden = false;
    }

    function checkout() {
      if (busy || !sel.length) return;
      if (errorEl) errorEl.hidden = true;
      setBusy(true);
      hideDrawers(cfg.hideDrawerSelectors);

      var attrs = {};
      if (cfg.attrKey) attrs[cfg.attrKey] = cfg.attrValue || 'true';

      var chain = Promise.resolve();
      if (cfg.clearCart) chain = chain.then(function () { return postJSON(cartRoot + 'cart/clear.js'); });
      if (cfg.attrKey) chain = chain.then(function () { return postJSON(cartRoot + 'cart/update.js', { attributes: attrs }); });

      chain.then(function () {
        if (cfg.checkoutMethod === 'ajax') {
          var items = sel.map(function (id) {
            var c = card(id);
            var it = { id: Number(c.dataset.variant), quantity: 1 };
            if (c.dataset.plan) it.selling_plan = Number(c.dataset.plan);
            return it;
          });
          return postJSON(cartRoot + 'cart/add.js', { items: items }).then(function () {
            window.location.href = cfg.checkoutUrl || '/checkout';
          });
        }
        // Build a native form post: /cart/add redirects to return_to (/checkout)
        Array.prototype.slice.call(form.querySelectorAll('[data-to-item]')).forEach(function (n) { n.remove(); });
        sel.forEach(function (id, i) {
          var c = card(id);
          if (!c) return;
          var fields = { id: c.dataset.variant, quantity: 1 };
          if (c.dataset.plan) fields.selling_plan = c.dataset.plan;
          Object.keys(fields).forEach(function (k) {
            var input = document.createElement('input');
            input.type = 'hidden';
            input.name = 'items[' + i + '][' + k + ']';
            input.value = fields[k];
            input.setAttribute('data-to-item', '');
            form.appendChild(input);
          });
        });
        if (cfg.attrKey) {
          var a = document.createElement('input');
          a.type = 'hidden';
          a.name = 'attributes[' + cfg.attrKey + ']';
          a.value = cfg.attrValue || 'true';
          a.setAttribute('data-to-item', '');
          form.appendChild(a);
        }
        HTMLFormElement.prototype.submit.call(form);
      }).catch(function (err) {
        setBusy(false);
        showError(err && (err.description || err.message));
      });
    }

    root.addEventListener('click', function (e) {
      var el = e.target.closest('button');
      if (!el || !root.contains(el)) return;

      if (el.hasAttribute('data-to-pick')) {
        toggle(el.closest('[data-to-card]').dataset.id);
      } else if (el.hasAttribute('data-to-continue')) {
        setStep('review');
      } else if (el.hasAttribute('data-to-back') || el.hasAttribute('data-to-add-more')) {
        setStep('pick');
      } else if (el.hasAttribute('data-to-remove')) {
        toggle(el.dataset.toRemove);
      } else if (el.hasAttribute('data-to-checkout')) {
        checkout();
      }
    });

    // If the shopper comes back with the browser back button, reset the button
    window.addEventListener('pageshow', function (e) {
      if (e.persisted && busy) setBusy(false);
      var style = document.getElementById('trial-offer-hide-drawers');
      if (e.persisted && style) style.remove();
    });

    // Themes that clip sections (overflow hidden) break position:sticky – fall back to normal flow
    (function () {
      var el = root.parentElement;
      while (el && el !== document.body) {
        var o = getComputedStyle(el);
        if (/(hidden|auto|scroll|clip)/.test(o.overflow + o.overflowY)) { root.classList.add('to-no-sticky'); break; }
        el = el.parentElement;
      }
    })();

    if (mobile.addEventListener) mobile.addEventListener('change', render);
    setInterval(function () {
      var day = root.querySelector('[data-to-ship-day]');
      if (day) day.textContent = shipDay(cfg);
    }, 60000);

    render();
  }

  function boot() {
    Array.prototype.forEach.call(document.querySelectorAll('[data-trial-offer]'), init);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();

  // Theme editor support
  document.addEventListener('shopify:section:load', function (e) {
    init(e.target.querySelector('[data-trial-offer]'));
  });
})();
